module.exports = __webpack_public_path__ + "static/fonts/OpenSans700.0062c346.ttf";